/**
 * @file dashboardConstants.js
 * @description Constants for the Dashboard module.
 *              Includes error messages for various dashboard data fetches.
 *
 * @module dashboardConstants
 *
 * @exports DASHBOARD_ERRORS - Error message strings for dashboard data fetching operations.
 */
export const DASHBOARD_ERRORS = {
    FETCH_OPTIN_ERROR: "Error fetching optin data.",
    FETCH_LANGUAGE_ERROR: "Error fetching language data.",
    FETCH_PROMISES_ERROR: "Error fetching promises data.",
    FETCH_CONVERSATION_TIME_ERROR: "Error fetching conversation time data.",
    FETCH_DPD_ERROR: "Error fetching DPD data.",
    FETCH_ACTIVITY_ERROR: "Error fetching activity data.",
    FETCH_COMPLIANCE_STATS_ERROR: "Error fetching compliance stats data.",
};